<template id="backToTop">
  <div id="imagecont" :class="generalBackground">
    <div style="height: 70px;"></div>
    <b-container v-show="picvisible">
      <!-- <b-container class="backrow bv-example-row bv-example-row-flex-cols"  :style="{ background: 'url(' + backRowStyle + ')'+' center / cover no-repeat' }"> -->
      <b-container :class="backRowStyle" class="bv-example-row bv-example-row-flex-cols">
        <!-- <b-container class="backrow bv-example-row bv-example-row-flex-cols" :style="backRowStyle"> -->
        <b-row class="titlepos align-items-center" :class="textVendor">
          <b-col class="mt-5" align-self="center">
            <div v-if="sharedLogoUrl" class="header-logo mb-3">
              <img :src="sharedLogoUrl" alt="Vendor logo" />
            </div>

            <div class="headline-text">
              Drive now, Pay Later !
            </div>
            <div class="subheadline-text">
              by ezFixd.com
            </div>
          </b-col>
        </b-row>
      </b-container>
      <!-- <b-container class="bv-example-row">
        <b-row cols="12" class="buttonloc justify-content-md-center">
          <b-col col lg="4">
            <b-button
              block
              size="lg"
              class="buttontextsize"
              style="height: 70px; font-weight: bold;"
              :class="[isActive ? 'red' : 'blue']"
              @click="toggleClass()"
              >Enter Make / Model</b-button
            >
          </b-col>
          <b-col col lg="4">
            <b-button
              block
              size="lg"
              class="buttontextsize"
              style="height: 70px; font-weight: bold;"
              :class="[isActive ? 'blue' : 'red']"
              @click="toggleClassTwo()"
              >Enter VIN</b-button
            >
          </b-col>
        </b-row>
      </b-container> -->
      <b-container fluid="lg" class="mt-4">
        <!-- LOCATION PICKER -->
        <b-row v-if="showLocationPicker" class="justify-content-md-center">
          <b-col cols="12" md="11" lg="10" xl="8">
            <b-card class="location-card" body-class="location-card-body">
              <div class="text-center mb-3">
                <div class="location-icon-wrap">
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#4a7cff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 6-9 13-9 13S3 16 3 10a9 9 0 1 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                </div>
                <div class="location-kicker">Almost there</div>
                <h4 class="mb-1">Select your location</h4>
                <p class="text-muted mb-0">Choose where you'd like to get service</p>
              </div>

              <!-- Search filter (shown when 5+ locations) -->
              <div v-if="vendorChoices.length >= 5" class="location-search-wrap mb-3">
                <svg class="location-search-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                <input
                  v-model="locationSearch"
                  type="text"
                  class="location-search"
                  placeholder="Search locations…"
                />
              </div>

              <!-- Location count -->
              <div class="location-count mb-2">
                {{ filteredVendors.length }} location{{ filteredVendors.length !== 1 ? 's' : '' }} available
              </div>

              <!-- Scrollable grid -->
              <div class="location-grid-scroll">
                <div class="location-grid">
                  <div
                    v-for="v in filteredVendors"
                    :key="v.id"
                    class="location-grid-card"
                    :class="{ 'location-grid-card--hover': hoveredVendor === v.id }"
                    @mouseenter="hoveredVendor = v.id"
                    @mouseleave="hoveredVendor = null"
                    @click="selectVendor(v.id)"
                  >
                    <div class="location-grid-card__pin">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 6-9 13-9 13S3 16 3 10a9 9 0 1 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                    </div>
                    <div class="location-grid-card__body">
                      <div class="location-grid-card__name">{{ v.label }}</div>
                      <div v-if="v.sub" class="location-grid-card__sub">{{ v.sub }}</div>
                    </div>
                    <div class="location-grid-card__arrow">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                    </div>
                  </div>
                </div>

                <!-- Empty state -->
                <div v-if="filteredVendors.length === 0" class="location-empty">
                  <p>No locations match your search.</p>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>

        <!-- NORMAL FLOW -->
        <div v-else>
          <div
            v-if="vendorChoices.length > 1"
            class="d-flex justify-content-between align-items-center mb-3"
          >
            <div class="location-pill">Location: {{ selectedVendorLabel }}</div>
            <b-button size="sm" variant="link" class="p-0" @click="changeLocation">
              Change
            </b-button>
          </div>

          <VandM :message="isActive"></VandM>
        </div>
      </b-container>
    </b-container>
    <transition name="fade">
      <div v-if="visible" class="vue-back-to-top">
        <VandM :message="msg" />
      </div>
    </transition>
  </div>
</template>

<script>
import $ from 'jquery'
import logoMap from '@/assets/logos'

export default {
  name: 'Main',
  props: {
    text: {
      type: String,
      default: 'text',
    },
    visibleoffset: {
      type: [String, Number],
      default: 600,
    },
    left: {
      type: String,
      default: '0px',
    },
    bottom: {
      type: String,
      default: '0px',
    },
  },
  data() {
    return {
      msg: 'i did it',
      showCreditCard: true,
      buttontoggler: 'primary',
      opbuttontoggler: 'outline-primary',
      myToggle: false,
      isActive: false,
      visible: false,
      picvisible: true,
      textone: 'omer',
      showstar: false,
      mycolor: '0E78E1',
      parameters: '',
      image:
        'http://1.bp.blogspot.com/-8PfnHfgrH4I/TylX2v8pTMI/AAAAAAAAJJ4/TICBoSEI57o/s1600/search_by_image_image.png',
      appData: {
        backgroundObject: 'backwidg.png',
        backgroundObjectGrizzly: 'grizzly.png',
      },
      showLocationPicker: false,
      vendorChoices: [],
      selectedVendorId: null,
      sharedLogoUrl: '',
      locationSearch: '',
      hoveredVendor: null,
    }
  },
  computed: {
    effectiveVendor() {
      return (
        this.selectedVendorId ||
        this.$store.state.userData.selectedVendor ||
        this.$route.query.vendor
      )
    },

    selectedVendorLabel() {
      const found = this.vendorChoices.find(v => v.id === this.selectedVendorId)
      return found && found.label ? found.label : 'Selected location'
    },

    filteredVendors() {
      if (!this.locationSearch.trim()) return this.vendorChoices
      const q = this.locationSearch.toLowerCase().trim()
      return this.vendorChoices.filter(
        v =>
          (v.label && v.label.toLowerCase().includes(q)) ||
          (v.sub && v.sub.toLowerCase().includes(q))
      )
    },

    backRowStyle() {
      const v = this.effectiveVendor
      if (v === '619d60ac3ddfde0bc5120f14') return 'backrowGrizzly'
      return 'backrow'
    },

    generalBackground() {
      const v = this.effectiveVendor
      if (v === '619d60ac3ddfde0bc5120f14') return 'grizzlyBackground'
      return 'generalBackground'
    },

    textVendor() {
      const v = this.effectiveVendor
      if (v === '619d60ac3ddfde0bc5120f14') return 'grizzlyText'
      return 'generalText'
    },
  },

  beforeMount() {
    const urlParams = new URLSearchParams(window.location.search)

    const vendorParam = urlParams.get('vendor') || ''
    console.log('vendorParam:', vendorParam)
    const labelsParam = urlParams.get('vendorLabels') || ''

    const vendorIds = vendorParam
      .split(',')
      .map(s => s.trim())
      .filter(Boolean)
    const vendorLabels = labelsParam
      .split(',')
      .map(s => s.trim())
      .filter(Boolean)

    const productDescription = urlParams.get('productDescription')
    const price = urlParams.get('price')
    const logoParam = urlParams.get('logo') || ''
    this.$store.state.userData.selectedProduct = productDescription
    this.$store.state.userData.productPrice = price
    this.$store.state.userData.repairOfferAmount = price
    this.sharedLogoUrl = logoMap[logoParam] || ''

    if (vendorIds.length === 0) {
      this.$store.state.userData.selectedVendor = '5e595abe5f786369a72bfd3f'
      return
    }

    if (vendorIds.length === 1) {
      this.selectedVendorId = vendorIds[0]
      this.$store.state.userData.selectedVendor = vendorIds[0]

      // optional: store for UI
      this.vendorChoices = [
        {
          id: vendorIds[0],
          label: vendorLabels[0] || 'Location',
          sub: '',
          logo: this.sharedLogoUrl,
        },
      ]
      return
    }

    this.vendorChoices = vendorIds.map((id, i) => ({
      id: id,
      label: vendorLabels[i] || `Location ${i + 1}`,
      sub: '',
      logo: this.sharedLogoUrl,
    }))

    this.showLocationPicker = true
  },
  async mounted() {
    const urlParams = new URLSearchParams(window.location.search)
    const vendorParam = urlParams.get('vendor') || ''
    const vendorIds = vendorParam
      .split(',')
      .map(s => s.trim())
      .filter(Boolean)

    // No vendor IDs in URL → default vendor was already set in beforeMount, skip fetch
    if (vendorIds.length === 0) return

    try {
      const vendors = await this.$store.dispatch('fetchVendorsById', vendorIds)

      this.vendorChoices = vendors.map(v => ({
        id: v.id || v._id,
        label: v.name || v.username,
        sub: v.address || '',
      }))
    } catch (e) {
      console.error(e)
    }
  },
  methods: {
    selectVendor(id) {
      this.selectedVendorId = id
      this.$store.state.userData.selectedVendor = id
      this.showLocationPicker = false
    },

    changeLocation() {
      if (this.vendorChoices.length > 1) {
        this.showLocationPicker = true
      }
    },
    toggleClass() {
      console.log(this.$store.state.userData.step)
      if (this.$store.state.userData.step > 1) {
        this.$store.state.userData.step = 0
        location.reload()
      } else {
        if ((this.isActive = true)) this.isActive = !this.isActive
      }
    },
    toggleClassTwo() {
      console.log(this.$store.state.userData.step)
      if (this.$store.state.userData.step > 1) {
        this.$store.state.userData.step = 0
        location.reload()
      } else {
        if ((this.isActive = false)) console.log(this.isActive)
        this.isActive = !this.isActive
      }
    },
    onpicOne() {
      if ('parentIFrame' in window) window.parentIFrame.size(560)
      return false
    },
    onpicTwo() {
      return [(this.visible = true), (this.picvisible = false)]
    },
  },
  template: '#backToTop',
}
</script>
<style scoped media="screen">
@import url('https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Inter+Tight:ital,wght@1,900&display=swap');
.header-logo {
  width: 276px;
  height: 150px;
  margin: 0 auto;
  border-radius: 18px;
  overflow: hidden;
  background: transparent;
  border: none;
  box-shadow: none;
}

.header-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* Keeps headline spacing consistent */
.headline-text {
  line-height: 1.1;
}
.subheadline-text {
  padding-top: 5px;
  line-height: 0.9;
  font: 600 1rem 'Open Sans', sans-serif;
}

.location-card {
  border-radius: 22px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.07);
  background: #fff;
  overflow: hidden;
}

.location-card-body {
  padding: 1.5rem;
}

@media (min-width: 768px) {
  .location-card-body {
    padding: 2rem;
  }
}

.location-icon-wrap {
  width: 52px;
  height: 52px;
  margin: 0 auto 10px;
  border-radius: 50%;
  background: #eef3ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.location-kicker {
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #6c757d;
  font-weight: 700;
}

/* --- Search --- */
.location-search-wrap {
  position: relative;
}

.location-search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.location-search {
  width: 100%;
  padding: 10px 14px 10px 38px;
  border-radius: 12px;
  border: 1px solid #e0e4ec;
  background: #f8f9fb;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.location-search:focus {
  border-color: #4a7cff;
  box-shadow: 0 0 0 3px rgba(74, 124, 255, 0.12);
  background: #fff;
}

.location-count {
  font-size: 12px;
  font-weight: 600;
  color: #999;
}

/* --- Scrollable grid container --- */
.location-grid-scroll {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 4px;
  scrollbar-width: thin;
  scrollbar-color: #d0d5dd transparent;
}

@media (min-width: 992px) {
  .location-grid-scroll {
    max-height: 400px;
  }
}

.location-grid-scroll::-webkit-scrollbar {
  width: 5px;
}

.location-grid-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.location-grid-scroll::-webkit-scrollbar-thumb {
  background: #d0d5dd;
  border-radius: 999px;
}

/* --- Grid --- */
.location-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

@media (max-width: 576px) {
  .location-grid {
    grid-template-columns: 1fr;
  }
}

@media (min-width: 577px) and (max-width: 768px) {
  .location-grid {
    grid-template-columns: 1fr;
  }
}

/* --- Card --- */
.location-grid-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  border-radius: 14px;
  border: 1px solid #e8ecf2;
  background: #fafbfd;
  cursor: pointer;
  transition: transform 0.12s ease, box-shadow 0.12s ease, border-color 0.12s ease;
  user-select: none;
}

@media (min-width: 768px) {
  .location-grid-card {
    padding: 14px 16px;
  }
}

.location-grid-card:hover,
.location-grid-card--hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(74, 124, 255, 0.10);
  border-color: #4a7cff;
}

.location-grid-card:active {
  transform: scale(0.98);
}

.location-grid-card__pin {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #eef3ff;
  color: #4a7cff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.location-grid-card:hover .location-grid-card__pin,
.location-grid-card--hover .location-grid-card__pin {
  background: #4a7cff;
  color: #fff;
}

.location-grid-card__body {
  flex: 1;
  min-width: 0;
}

.location-grid-card__name {
  font-weight: 700;
  font-size: 14px;
  color: #1e2a3a;
  white-space: normal;
  word-break: break-word;
}

.location-grid-card__sub {
  font-size: 11px;
  color: #8a94a6;
  white-space: normal;
  word-break: break-word;
  margin-top: 1px;
}

.location-grid-card__arrow {
  flex-shrink: 0;
  color: #c0c7d3;
  transition: color 0.12s, transform 0.12s;
}

.location-grid-card:hover .location-grid-card__arrow {
  color: #4a7cff;
  transform: translateX(2px);
}

.location-empty {
  text-align: center;
  padding: 32px 16px;
  color: #999;
  font-size: 14px;
}

.location-item {
  border-radius: 14px !important;
  margin-bottom: 10px;
  padding: 14px 16px;
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  transition: transform 0.08s ease, box-shadow 0.08s ease;
}

.location-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.08);
}

.location-name {
  font-weight: 800;
  font-size: 15px;
  color: #2f2f2f;
}

.location-sub {
  font-size: 12px;
  color: #6c757d;
}

.location-pill {
  background: #f3f6ff;
  border: 1px solid #dbe4ff;
  color: #2b3a67;
  padding: 6px 10px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 13px;
}

.location-cta {
  border-radius: 999px;
  padding-left: 14px;
  padding-right: 14px;
}

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
  margin: 1em 0;
  padding: 0;
}

.align-items-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap');

@media screen and (min-width: 1501px) {
  .titlepos {
    font-size: 2vw;
  }
}

@media screen and (min-width: 1001px) and (max-width: 1500px) {
  .titlepos {
    font-size: 3.5vw;
  }
}

@media screen and (min-width: 401px) and (max-width: 1000px) {
  .titlepos {
    font-size: 5vw;
  }
}

@media screen and (max-width: 400px) {
  .titlepos {
    font-size: 7vw;
  }
}

@media screen and (min-width: 1001px) and (max-width: 1500px) {
  .buttontextsize {
    font-size: 2vw;
  }
}

@media screen and (min-width: 701px) and (max-width: 1000px) {
  .buttontextsize {
    font-size: 2.5vw;
  }
}

@media screen and (min-width: 401px) and (max-width: 700px) {
  .buttontextsize {
    font-size: 3vw;
  }
}

@media screen and (max-width: 400px) {
  .buttontextsize {
    font-size: 4vw;
  }
}

.titlepos {
  position: absolute;
  margin-left: 0px;
  margin-right: 0px;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 250px;
  color: black;
  font-family: 'Inter Tight', sans-serif;
  color: #3b3b3b;
}
.red {
  border-color: #109de7;
  background: white;
  color: black;
}

.blue {
  background-color: #109de7;
  border-color: #109de7;
}

.am-active {
  background-color: rgb(21, 79, 202);
  color: white;
}

.am-not-active {
  background-color: white;
}

.alignit {
  text-align: center;
  border: 3px solid green;
}

.buttonvin {
  background-color: white;
}

.buttonmake {
  background-color: #109de7;
}

.backrow {
  background: url('../assets/images/backwidg.png') center / cover no-repeat;
  width: 100%;
  height: 300px;
  object-fit: cover;
  position: relative;
}

.backrowGrizzly {
  background: url('../assets/images/grizzly.png') center / cover no-repeat;
  width: 100%;
  height: 300px;
  object-fit: cover;
  position: relative;
}

.testdiv {
  background: url('../assets/images/backwidg.png') center / cover no-repeat;
}

.vue-back-to-top {
  z-index: 1000;
  cursor: pointer;
  position: fixed;
}

.buttonloc {
  margin-top: -20px;
}

.generalBackground {
  background-color: white;
}

.grizzlyBackground {
  background: url('../assets/images/backgroundCarParts.png');
  background-repeat: repeat;
}

.generalText {
  color: black;
}

.grizzlyText {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/main.vue